import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TuiGroup, TuiButton, TuiHint } from '@taiga-ui/core';
import { TuiAccordion, TuiTabs, TuiButtonLoading } from '@taiga-ui/kit';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '@src/app/components';

import { HintModule } from '../../modules/hint/hint.module';

import { SelectItemsComponent } from './select-items.component';

@NgModule({
  declarations: [SelectItemsComponent],
  imports: [
    CommonModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    ...TuiAccordion,
    TuiButton,
    TuiGroup,
    ...TuiHint,
    ...TuiTabs,
    HintModule,
    TranslateModule,
    ComponentsModule,
      TuiButtonLoading
],
  exports: [SelectItemsComponent],
})
export class SelectItemsModule {}
